import InterestsList from './InterestsList'

export default InterestsList
